import {
  Component,
  OnInit,
  AfterViewInit,
  OnChanges,
  Input,
  SimpleChanges,
  OnDestroy,
} from "@angular/core";
import { DataService } from "./data.service";
import * as Highcharts from "highcharts";
import addMore from "highcharts/highcharts-more";
import { WidgetConfig } from "../../../class/widget-config";
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { LocalStorageService } from "../../../../shared/services/local-storage.service";
import { BroadcasterService } from "../../../../core/services/broadcaster.service";
import { GenericUtils } from './../../../utilities/generic-utils';

addMore(Highcharts);
@Component({
  selector: 'widget-multi-column-column-chart',
  templateUrl: './widget-multi-column-column-chart.component.html',
  styleUrls: ['./widget-multi-column-column-chart.component.scss']
})
export class WidgetMultiColumnColumnChartComponent implements OnInit, OnDestroy, OnChanges {
  @Input() FILTERS;
  @Input() WIDGETCONFIG: WidgetConfig;
  @Input() CHARTCONFIG;
  highcharts: typeof Highcharts = Highcharts;
  chartOptions = null;
  errorMessage = "";
  mockChart = null;
  loadingChart = false;
  errorLoadingChart = false;
  private unsubscribe: Subject<void> = new Subject();


  constructor(
    private dataService: DataService,
    private broadcaster: BroadcasterService,
    private localStorageService: LocalStorageService,
    private genericUtils: GenericUtils
  ) { }



  ngOnChanges(changes: SimpleChanges) {
    this.getData();
  }

  ngOnInit() {
    this.broadcaster.listen("PAGE_WIDGET_DATA").pipe(takeUntil(this.unsubscribe)).subscribe(() => {
      //this.setWidgetData();
    });
  }

  setWidgetData() {
    const pageData = this.localStorageService.getItem("PAGE_WIDGET_DATA");
    if (pageData) {
      pageData.forEach(element => {
        if (element.widget_id === this.WIDGETCONFIG.id) {
          this.setTarget(element.target);
        }
      });
    }
  }

  setTarget(t) {
    if (this.chartOptions) {
      const lastElement = this.chartOptions.series.length - 1;
      this.chartOptions.series[lastElement] = {
        type: "line",
        name: "Target",
        showInLegend: false,
        data: [],
        dashStyle: "ShortDash",
        color: "#979797",
        tooltip: { valueSuffix: "%" },
        enableMouseTracking: false
      };
      for (let i = 0; i < this.chartOptions.series[0].data.length; i++) {
        this.chartOptions.series[lastElement].data.push(t);
      }
    }
  }
  getData() {
    this.chartOptions = null;
    this.errorMessage = "";
    this.mockChart = null;
    this.loadingChart = true;
    this.errorLoadingChart = false;
    this.dataService.getData(this.WIDGETCONFIG.api, this.WIDGETCONFIG, this.FILTERS)
      .pipe(takeUntil(this.unsubscribe)).subscribe(
        chartData => {
          this.loadingChart = false;
          if (chartData) {
            this.chartOptions = this.dataService.createChart(
              chartData,
              this.CHARTCONFIG
            );
            //this.chartOptions.series[0].data = [...this.chartOptions.series[0].data];
            this.setWidgetData();
          } else {
            this.handleError("ERROR_MSG.NO_DATA");
          }
        },
        error => {
          this.loadingChart = false;
          this.handleError("ERROR_MSG.SYSTEM_ERROR");
        }
      );
  }

  handleError(message) {
    this.errorLoadingChart = true;
    this.errorMessage = message;
    this.mockChart = [{ chart: this.CHARTCONFIG[0], width: 12 }];

  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

}
